import React, { useEffect, useRef, useState } from 'react';
import './Menu.css';
import { useSelector, useDispatch } from 'react-redux';
import { setActiveMenuItem } from '../../store/menuSlice.js';
import { clearTokens } from '../../store/tokensSlice.js';
import MenuButton from './menuButton.jsx';

import { ReactComponent as Ticket } from '../icons/ticket.svg';
import { ReactComponent as StatusUp } from '../icons/status-up.svg';
import { ReactComponent as Logout } from '../icons/logout.svg';
import { ReactComponent as Settings } from '../icons/settings.svg';
import { ReactComponent as UserSquare } from '../icons/user-square.svg';
import { ReactComponent as UserEdit } from '../icons/user-edit.svg';
import { ReactComponent as Cup } from '../icons/cup.svg';
import { ReactComponent as MapenLogo } from '../icons/logo.svg';

import { useLocation } from 'react-router-dom';
import ProfileModal from './profileModal.jsx';
import SettingsModal from './settingsModal.jsx';

function Menu() {
  const location = useLocation();
  const activeLink = useSelector((state) => state.menu.activeMenuItem);
  const dispatch = useDispatch();

  const [isProfileModalOpen, setProfileModalOpen] = useState(false);
  const [isSettingsModalOpen, setSettingsModalOpen] = useState(false);
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const userMenuRef = useRef(null);

  const handleLinkClick = (path) => {
    dispatch(setActiveMenuItem(path));
  };

  useEffect(() => {
    handleLinkClick(location.pathname);
  }, [location.pathname]);

  const handleLogoutClick = () => {
    dispatch(clearTokens());
    window.location.reload();
  };

  const handleProfileClick = () => {
    setIsUserMenuOpen(false);
    setProfileModalOpen(true);
  };

  const handleChangePasswordClick = () => {
    setIsUserMenuOpen(false);
    setSettingsModalOpen(true);
  };

  const menuItems = [
    { path: '/', icon: Ticket, label: 'Wydarzenia' },
    { path: '/promo', icon: Cup, label: 'Promowanie' },
    { path: '/statistics', icon: StatusUp, label: 'Statystyki' },
  ];

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (userMenuRef.current && !userMenuRef.current.contains(event.target)) {
        setIsUserMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);
    return () => document.removeEventListener('mousedown', handleOutsideClick);
  }, []);

  const userToolsStyle = {
    position: 'relative',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    paddingLeft: '12px',
    borderLeft: '3px solid #D5DADE70',
  };

  const iconButtonStyle = {
    width: '44px',
    height: '44px',
    border: 'none',
    borderRadius: '8px',
    background: 'transparent',
    color: '#ffffff',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
  };

  const dropdownStyle = {
    position: 'absolute',
    top: 'calc(100% + 10px)',
    right: 0,
    minWidth: '220px',
    background: '#ffffff',
    border: '1px solid #d1d5db',
    borderRadius: '8px',
    boxShadow: '0 10px 24px rgba(0, 0, 0, 0.18)',
    padding: '6px',
    zIndex: 1200,
  };

  const dropdownItemStyle = {
    width: '100%',
    border: 'none',
    borderRadius: '6px',
    background: 'transparent',
    color: '#1f2937',
    padding: '10px 10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '10px',
    textAlign: 'left',
    fontSize: '14px',
    cursor: 'pointer',
  };

  const dropdownIconStyle = { width: '19px', height: '19px', flex: '0 0 19px', color: '#2F5F6D' };

  return (
    <div className="menu">
      <div className="menu-content">
        <div className="menu-logo">
          <MapenLogo className="menu-icon-without-text" />
        </div>

        <div className="menu-center">
          {menuItems.map((item) => (
            <MenuButton
              key={item.path}
              path={item.path}
              currentPath={activeLink}
              onClick={handleLinkClick}
              icon={item.icon}
              label={item.label}
              showLabel={true}
              showSpeechBubble={true}
            />
          ))}
        </div>

        <div className="menu-right">
          <div ref={userMenuRef} style={userToolsStyle}>
            <button
              type="button"
              onClick={() => setIsUserMenuOpen((prev) => !prev)}
              aria-label="Menu profilu"
              title="Menu profilu"
              style={iconButtonStyle}
            >
              <UserSquare style={{ width: '24px', height: '24px' }} />
            </button>

            {isUserMenuOpen && (
              <div style={dropdownStyle}>
                <button type="button" onClick={handleProfileClick} style={dropdownItemStyle}>
                  <UserEdit aria-hidden="true" style={dropdownIconStyle} />
                  <span>Edytuj profil</span>
                </button>
                <button type="button" onClick={handleChangePasswordClick} style={dropdownItemStyle}>
                  <Settings aria-hidden="true" style={dropdownIconStyle} />
                  <span>Zmień hasło</span>
                </button>
                <button type="button" onClick={handleLogoutClick} style={dropdownItemStyle}>
                  <Logout aria-hidden="true" style={dropdownIconStyle} />
                  <span>Wyloguj</span>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      {isProfileModalOpen && (
        <ProfileModal
          onClose={() => setProfileModalOpen(false)}
        />
      )}

      {isSettingsModalOpen && (
        <SettingsModal
          onClose={() => setSettingsModalOpen(false)}
        />
      )}
    </div>
  );
}

export default Menu;
